/**
 * ID interno del proveedor en SAI (la CVE_PROV): entero de 1 a 99999.
 * Es opcional. El input lo maneja como texto; al API se manda como número,
 * nunca como cadena vacía (el back la convertiría en 0 y respondería 400).
 */
const ID_SAI_MAXIMO = 99999

export const validarIdSai = (valor: string | undefined | null): true | string => {
  const texto = (valor ?? '').trim()
  if (texto === '') return true
  if (!/^\d+$/.test(texto)) return 'Debe ser un número entero'
  const n = Number(texto)
  if (n < 1 || n > ID_SAI_MAXIMO) return `Debe estar entre 1 y ${ID_SAI_MAXIMO}`
  return true
}

/** Para altas e invitaciones: vacío se omite. */
export const idSaiParaAlta = (valor: string | undefined | null): number | undefined => {
  const texto = (valor ?? '').trim()
  return texto === '' ? undefined : Number(texto)
}

/** Para edición: vacío manda null, que borra el ID ya guardado. */
export const idSaiParaEdicion = (valor: string | undefined | null): number | null =>
  idSaiParaAlta(valor) ?? null

export const idSaiComoTexto = (valor: number | null | undefined): string =>
  valor != null ? String(valor) : ''
